<ng-container *ngIf="proposal">
  <mat-accordion [multi]="true" displayMode="flat" class="accordion-container">

    <!-- Partner information -->
    <mat-expansion-panel [disabled]="isPartnerEmpty()" [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'proposalDetails.partnerInformation' | translate}}</span>
          <span *ngIf="isChanged('partner')" class="section-changed-badge">
            {{'proposalDetails.versionHistoryTab.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-partner-info
        [proposal]="proposal"></app-insurance-contract-detail-partner-info>
    </mat-expansion-panel>

    <hr>
    <!-- Risk details -->
    <mat-expansion-panel [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'proposalDetails.theRisk' | translate}}</span>
          <span *ngIf="isChanged('risk')" class="section-changed-badge">
            {{'proposalDetails.versionHistoryTab.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-risk-info
        [proposal]="proposal"></app-insurance-contract-detail-risk-info>
    </mat-expansion-panel>

    <hr>
    <!-- Insured sum -->
    <mat-expansion-panel [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'proposalDetails.sums' | translate}}</span>
          <span *ngIf="isChanged('sums')" class="section-changed-badge">
            {{'proposalDetails.versionHistoryTab.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-sum-insureds
        [proposal]="proposal"></app-insurance-contract-detail-sum-insureds>
    </mat-expansion-panel>

    <hr>
    <!-- Risk description -->
    <mat-expansion-panel
      [disabled]="proposal.proposalInformation.riskDescriptionFreeText === null || proposal.proposalInformation.riskDescriptionFreeText === ''"
      [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'proposalDetails.riskDescription' | translate}}</span>
          <span *ngIf="isChanged('riskDescription')" class="section-changed-badge">
            {{'proposalDetails.versionHistoryTab.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-risk-description
        [proposal]="proposal"></app-insurance-contract-detail-risk-description>
    </mat-expansion-panel>

    <hr>
    <!-- Risk locations -->
    <mat-expansion-panel [disabled]="proposal.riskLocations.length == 0" [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'proposalDetails.riskLocation' | translate}}</span>
          <span *ngIf="isChanged('riskLocations')" class="section-changed-badge">
            {{'proposalDetails.versionHistoryTab.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-risk-locations
        [proposal]="proposal"></app-insurance-contract-detail-risk-locations>
    </mat-expansion-panel>

    <hr>
    <!-- International programs -->
    <mat-expansion-panel
      [disabled]="proposal.proposalInformation.countriesWithLocalPolicies == null || proposal.proposalInformation.countriesWithLocalPolicies?.length == 0"
      [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'proposalDetails.internationalPrograms' | translate}}</span>
          <span *ngIf="isChanged('internationalProgram')" class="section-changed-badge">
            {{'proposalDetails.versionHistoryTab.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-proposal-detail-international-program
        [proposal]="proposal"></app-proposal-detail-international-program>
    </mat-expansion-panel>

    <hr>
    <!-- Previous damages -->
    <mat-expansion-panel [disabled]="proposal.previousDamages.length === 0" [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'proposalDetails.previousDamages' | translate}}</span>
          <span *ngIf="isChanged('previousDamages')" class="section-changed-badge">
            {{'proposalDetails.versionHistoryTab.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-previous-damages
        [insuranceContract]="proposal"></app-insurance-contract-detail-previous-damages>
    </mat-expansion-panel>

    <hr>
    <!-- Individual clauses & conditions -->
    <mat-expansion-panel
      [disabled]="
        (proposal.proposalInformation.individualConditionsFreeText === null || proposal.proposalInformation.individualConditionsFreeText === '') &&
        (proposal.proposalInformation.individualClausesFreeText === null || proposal.proposalInformation.individualClausesFreeText === '')"
      [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'proposalDetails.individualClausesConditions' | translate}}</span>
          <span *ngIf="isChanged('individualClausesConditions')" class="section-changed-badge">
            {{'proposalDetails.versionHistoryTab.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-individual-clauses-conditions
        [proposal]="proposal"></app-insurance-contract-detail-individual-clauses-conditions>
    </mat-expansion-panel>

    <hr>
    <!-- Proposal information -->
    <mat-expansion-panel [togglePosition]="'before'">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'proposalDetails.proposalInformation' | translate}}</span>
          <span *ngIf="isChanged('proposalInformation')" class="section-changed-badge">
            {{'proposalDetails.versionHistoryTab.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-insurance-contract-detail-advertisement-info
        [insuranceContract]="proposal" [usersAllowedToView]="[]"></app-insurance-contract-detail-advertisement-info>
    </mat-expansion-panel>

    <hr>
    <!-- Attached files -->
    <mat-expansion-panel
      [disabled]="proposal.proposalInformation.attachedFiles.length == 0"
      [togglePosition]="'before'"
      class="mb-4">
      <mat-expansion-panel-header [@.disabled]="true">
        <mat-panel-title>
          <span class="panel-title-text">{{'proposalDetails.files' | translate}}</span>
          <span *ngIf="isChanged('files')" class="section-changed-badge">
            {{'proposalDetails.versionHistoryTab.changed' | translate}}
          </span>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-version-history-files
        [attachedFiles]="proposal.proposalInformation.attachedFiles"
        [existingFileIds]="existingFileIds"></app-version-history-files>
    </mat-expansion-panel>

  </mat-accordion>
</ng-container>
